import { History } from 'history'

export enum GenericApiErrors {
  Failed,
}

export interface PendingReceivementsState {
  pendingReceivements: PendingReceivements
  receivementConference?: ReceivementConference
  badgeStatus: BadgeStatus
  badge?: string
  loading: boolean
  sendReceivementConferenceLoading: boolean
  approveCheckboxesValues: Record<number, boolean>
}

export interface PendingReceivement {
  waitingTime: Date;
  dateReceivement: Date;
  dock: number;
  idReceivement: number;
  supplierName: string;
}

export type PendingReceivements = PendingReceivement[];

export interface SetPendingReceivements {
  pendingReceivements: PendingReceivementsState['pendingReceivements'];
}

export interface ProductWrong{
  description: string,
  modelId: number,
  idProductDivergence: number,
  wrongProductConfirmed: boolean,
  productCode: string
}

export type WrongProductData = Omit<ProductWrong, 'wrongProductConfirmed'>;

export interface InvoiceDetail{
  acceptedQuantity: number,
  boxQuantity: number,
  convertedQuantity: number,
  qtyPerBox: number,
  expectedQuantity: number,
  receivedQuantity: number,
  idAr: number,
  invoiceChecker: string,
  invoiceKey: string
  invoiceNumber: number
  invoiceUnitType: string
  invoiceProductName: string
  idArItem: number
  measureUnit: string
  buyer: string
}

export interface ReceivementConference {
  nfList: string[]
  productWrong: ProductWrong[]
  receivementConference: PendingReceivementConference[]
  allReceivementInvoices: string[]
  idReceivementCategory: number
}

export interface PendingReceivementConference {
  modelId: number,
  productDescription: string,
  codProduto: string,
  invoiceDetails: InvoiceDetail[]
  isFlv: boolean
}

export enum BadgeStatus {
  PENDING,
  APROVED,
}

export interface GetReceivementConferenceParams {
  badge?: string
  receivementId: number
}

export interface GetPendingReceivementPayload {
  fulfillmentCenterId: number
}

export interface SendReceivementConferenceParams {
  badge?: string
  receivementId: string
  receivementConference: PendingReceivementConference[]
  history: History
  setIsDisabled: React.Dispatch<React.SetStateAction<boolean>>
}

export interface InvoicesManagementModalSchemaType {
  invoiceKeyInput: string
}

export interface ValidateInvoiceKeyApiParams {
  receivementId: number
  invoiceKey: string
  badge: string
}

export type ValidateInvoiceKeySagaParams = {
  setError: (error: string) => void
  onSuccess: () => void
  setIsDisabled: React.Dispatch<React.SetStateAction<boolean>>
} & ValidateInvoiceKeyApiParams

export interface ApplyInvoicesManagementApiParams {
  receivementId: number
  invoiceKeys: string[]
  badge: string
}

export type ApplyInvoicesManagementSagaParams = {
  onSuccess: () => void
  setIsDisabled: React.Dispatch<React.SetStateAction<boolean>>
} & ApplyInvoicesManagementApiParams

export interface UnreceivedProduct {
  idModel: number
  idArItem: number
  invoiceNumber: number
  invoiceProductName: string
  invoiceUnitType: string
  originalQuantity: number
  convertedQuantity: number
}

export interface AssociateProductsReceivementPayload {
  badge: string
  receivementId: string
  idArItem: number
  currentIdModel: number
  newIdModel: number
  onSuccess: () => void
}

export interface ConfirmWrongProductPayload {
  badge: string
  idProductDivergence: number
  onSuccess: () => void
}

export enum ReceivementCategoryEnum {
  NORMAL = 1,
  EXTERNAL_PURCHASE = 2,
  TRANSFER = 3
}
